/* global axios */
import ApiClient from '../ApiClient';

class CopilotToolsAPI extends ApiClient {
  constructor() {
    super('copilot/tools', { accountScoped: true });
  }

  get({ page = 1, search } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        search,
      },
    });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }
}

export default new CopilotToolsAPI();
